import { Button, InputProps, TextField, Typography } from '@mui/material';
import React, { FormEventHandler, useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router';
import { NavLink as RouterLink } from 'react-router-dom';

import { Mcc } from 'app/model/cris/mcc';
import { mccService } from 'app/services/tools/mcc.service';
import { ModelWithoutId } from 'app/type';

export const MccForm: React.FunctionComponent = () => {
    const { id } = useParams<{ id: string }>();
    const history = useHistory();

    const [mcc, setMcc] = useState<ModelWithoutId<Mcc>>({ name: '', dateCreated: '', dateEdited: '' });

    const isNew = 'new' === id;

    const handleSubmit: FormEventHandler = (evt) => {
        evt.preventDefault();
        mccService.save(mcc).subscribe((cat) => {
            history.replace(`/cris/mccs/${cat.id}`);
        });
    };

    const handleCategoryChange: InputProps['onChange'] = (evt) => {
        setMcc({ ...mcc, [evt.target.name]: evt.target.value });
    };

    useEffect(() => {
        if (!isNew) {
            mccService.get(id).subscribe(setMcc);
        }
    }, [id, isNew]);

    return (
        <form onSubmit={handleSubmit}>
            <Typography variant='h6'>
                {isNew ? 'Create' : 'Edit'} MCC{isNew ? '' : `: ${id}`}
            </Typography>
            <div>
                <TextField
                    name='mccId'
                    label='Id'
                    className='mr-1'
                    disabled={!isNew}
                    value={mcc.mccId || ''}
                    onChange={handleCategoryChange}
                />
                <TextField name='name' label='Name' value={mcc.name} onChange={handleCategoryChange} />
            </div>
            <Button type='submit' variant='outlined' color='primary' className='mt-2'>
                Save
            </Button>
            <Button
                type='submit'
                variant='outlined'
                color='inherit'
                className='mt-2 ml-1'
                component={RouterLink}
                to='/cris/mccs'
            >
                Cancel
            </Button>
        </form>
    );
};
